export class SmsUtils {
    static isNumberPhone(phone: string): boolean {
        const patron: RegExp = /^\d{8}$/;
        return patron.test(phone);
      }
}